import { render, staticRenderFns } from "./OrganisationProfile.vue?vue&type=template&id=185e3a12&"
import script from "./OrganisationProfile.vue?vue&type=script&lang=js&"
export * from "./OrganisationProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports